import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import { useCallback, useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { createVerifyAccountOutbound } from '../../api/outbound/entryOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { useAppSelector } from '../../redux/store';
import { SubPageContainer } from '../components/subPageContainer';
export const VerifyPageContents = () => {
    const { uuid } = useParams();
    const socketSend = useSocketSend();
    const verifyResult = useAppSelector((state) => state.verifyAccount.verifyResult, shallowEqual);
    const navigate = useNavigate();
    useEffect(() => {
        if (verifyResult || !uuid) {
            return;
        }
        socketSend(createVerifyAccountOutbound(uuid));
    }, [socketSend, uuid, verifyResult]);
    const navigateHome = useCallback(() => {
        navigate('/');
    }, [navigate]);
    function getPlayNowButton() {
        return (_jsx(Button, { onClick: navigateHome, size: 'large', color: 'secondary', variant: 'contained', children: "Play Now!" }));
    }
    function getBackToHomeButton() {
        return (_jsx(Button, { onClick: navigateHome, size: 'large', color: 'secondary', variant: 'contained', children: "Back to Home" }));
    }
    function getContents() {
        if (!uuid) {
            return {
                heading: 'No verification code provided!',
                body: getBackToHomeButton()
            };
        }
        if (!verifyResult) {
            return {
                heading: 'Verifying...',
                body: null
            };
        }
        switch (verifyResult.type) {
            case 'success': {
                return {
                    heading: 'Thanks for verifying, all done!',
                    body: getPlayNowButton()
                };
            }
            case 'error': {
                return {
                    heading: verifyResult.error,
                    body: getBackToHomeButton()
                };
            }
        }
    }
    const { heading, body } = getContents();
    return (_jsxs(SubPageContainer, { title: 'Account Verification', omitExtraButtons: true, children: [_jsx("h3", { children: heading }), body] }));
};
